export const checkIsObjectWithKeys = (data: unknown): data is { [key: string]: unknown } => {
  return !!data && typeof data === 'object' && Object.keys(data).length > 0;
};
